var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc pa0 ma0"},[_c('img',{attrs:{"src":_vm.imageUrl,"width":_vm.width,"alt":_vm.project.name},on:{"error":_vm.useFallbackImage}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e87e207","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/vue/js/modules/pro/project/components/ProProjectThumbnailPhoto.vue
// module id = null
// module chunks = 